import React from 'react';

export interface RefresherProps extends React.PropsWithChildren {
  handleRefresh?: (event: CustomEvent<{ complete(): void }>) => void;
  isDisable?: boolean;
  scrollY?: boolean;
}

const Refresher: React.FC<RefresherProps> = ({ children }) => children;

export default Refresher;
